import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../common/hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { unacceptedAgreements } from '../../../services/agreementService';
import EmailStore from '../../../../common/services/config/emailStore';
import BaseURLConfigStore from '../../../../common/services/config/baseUrlConfigStore';
import IdentityManager from '../../../../common/services/identity/IdentityManagerFactory';
import { POPUP } from '../../../../redux/types';

import { IAgreements } from '../../types/IAgreements';

import Logo from '../../../ui/logo/logo';
import AgreementsTable from '../../components/agreementsTable/agreementsTable';
import Button from '../../../ui/button/button';

import './agreements.scss';

const Agreements: React.FC<IAgreements> = ({ declined }) => {
  const [agreements, setAgreements] = useState<any[]>([]);

  const { t } = useTranslate();
  const identity = IdentityManager.getManager();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const close = () => {
    navigate('/agreements');
  };

  useEffect(() => {
    unacceptedAgreements()
      .then((r) => {
        if (r.data && r.data.length === 0) {
          navigate(BaseURLConfigStore.getStartPageUrl() || '/home');
        }
        setAgreements(r.data);
      })
      .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, []);

  return (
    <div className='agreements-wrapper'>
      <div className='agreements-content'>
        <div className='agreements-header'>
          <div className='logo'>
            <Logo logoSource='/branding/logo.png' />
          </div>
        </div>
        <div className='agreements-title'>
          <span>{declined ? t('AGREEMENTS_DECLINED.TITLE') : t('AGREEMENTS.NAME')}</span>
        </div>
        {declined ? (
          <>
            <div className='consent-text info1'>
              <span>{t('AGREEMENTS_DECLINED.INFO_1')}</span>
              <br />
              <a className={'pointer login-page'} href={`mailto:${EmailStore.default_email}`}>
                {EmailStore.default_email}
              </a>
            </div>
            <div className='consent-text info2'>
              <span>{t('AGREEMENTS_DECLINED.INFO_2')}</span>
              <span className={'pointer login-page'} onClick={() => identity.signOut()}>
            {' '}
                {t('AGREEMENTS_DECLINED.LOGIN')}
          </span>
            </div>
          </>
        ) : (
          <div className='consent-text'>
            <span>{t('AGREEMENTS.INFO')}</span>
          </div>
        )}
        {!declined && <AgreementsTable agreements={agreements} />}
        <div className='button-group'>
          {!declined && <span className='approval-text'>{t('AGREEMENTS.APPROVE')}</span>}
          {!declined ? (
            <Button buttonStyle='button-wrapper button-wrapper-oval' handleClick={() => identity.signOut()}>
              {t('AGREEMENTS.LOGOUT')}
            </Button>
          ) : (
            <Button buttonStyle='button-wrapper button-wrapper-oval' handleClick={() => close()}>
              {t('AGREEMENTS_DECLINED.CLOSE')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Agreements;
